import React, {FC, useEffect, useState} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {Field, ErrorMessage} from 'formik'
import {useAuth} from '../../../../auth/core/Auth'
import {UsersQueryResponse} from '../../../user-management/users-list/core/_models'
import axios, {AxiosResponse} from 'axios'
import {getAuth} from '../../../../auth'

interface Step2Props {
  customerId: any
}

const auth = getAuth()
const API_URL = process.env.REACT_APP_API_URL
const GET_INVESTMENT_URL = `${API_URL}/customer/get_investments`
const GET_SCHEMES_URL = `${API_URL}/products/get_products`

const GET_TYPE_URL = `${API_URL}/admin/exchange_types`
const GET_SUB_TYPE_URL = `${API_URL}/admin/exchange_sub_types`
const GET_AMC_URL = `${API_URL}/admin/amc`

const config = {
  headers: {
    'Content-type': 'application/json',
    'x-access-token': auth ? auth.data.token : '',
  },
}

const getType = (): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_TYPE_URL}?${auth?.data.id}`, config)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getSubType = (): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_SUB_TYPE_URL}?limit=100`, config)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getAmc = (): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_AMC_URL}?limit=100`, config)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getSchemes = () => {
  return axios.get(`${GET_SCHEMES_URL}?limit=100`, config).then((d) => d.data)
}

const getUserInvestments = (): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_INVESTMENT_URL}?page=1&item_per_page=5000`, config)
    .then((I: AxiosResponse<UsersQueryResponse>) => I.data)
}

const Step2: FC<Step2Props> = ({customerId}) => {
  const currentUser = useAuth()
  const location = useLocation()
  const [userInvestments, setUserInvestments] = useState<any[]>([])
  const [schemes, setSchemes] = useState<any[]>([])
  const [types, setTypes] = useState<any[]>([])
  const [subTypes, setSubTypes] = useState<any[]>([])
  const [amcs, setAmcs] = useState<any[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    if (!auth && location.pathname.startsWith('/users/generate-customer-report')) {
      navigate('/auth/login')
    }
    let temp: any = []
    getUserInvestments()
      .then((I: any) => {
        I.data
          .filter((d: any) => d.customerId == customerId && d.status === 'approved')
          .map((I: any) => {
            temp.push(I)
          }, [])
      })
      .then(() => {
        setUserInvestments(temp)
      })
  }, [customerId])

  useEffect(() => {
    getType().then((d: any) => {
      setTypes(d.data)
    })
    getSubType().then((d: any) => {
      d.data.sort((a: any, b: any) => a.id - b.id)
      setSubTypes(d.data)
    })
    getAmc().then((d: any) => {
      d.data.sort((a: any, b: any) => a.id - b.id)
      setAmcs(d.data)
    })
    getSchemes().then((d: any) => {
      d.data.filter((d: any) => d?.status === 'approved')
      setSchemes(d.data)
    })
  }, [types.length, subTypes.length, amcs.length, schemes.length])

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-dark'>Select your preferences for the report</h2>
        <div className='text-gray-400 fw-bold fs-6'>
          {userInvestments[0]?.applicantGroupName}
          <a href='/dashboard' className='link-primary fw-bolder'>
            {` (${userInvestments[0]?.ucc ? userInvestments[0]?.ucc : '-'})`}
          </a>
        </div>
      </div>

      <div className='fv-row'>
        <div className='row mb-4'>
          <div className='col-lg-6'>
            <label className='required fw-bold fs-6 mb-6'>Product</label>

            <div className='fv-row'>
              <div className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input'
                  type='radio'
                  name='product'
                  value='all'
                  id='product_all'
                />
                <label className='form-check-label me-4' htmlFor='product_all'>
                  All
                </label>

                <Field
                  className='form-check-input'
                  type='radio'
                  name='product'
                  value='MARS'
                  id='product_mars'
                />
                <label className='form-check-label me-4' htmlFor='product_mars'>
                  MARS
                </label>

                <Field
                  className='form-check-input'
                  type='radio'
                  name='product'
                  value='Non-MARS'
                  id='product_non_mars'
                />
                <label className='form-check-label' htmlFor='product_non_mars'>
                  Non-MARS
                </label>
              </div>
            </div>

            <div className='text-danger mt-2'>
              <ErrorMessage name='product' />
            </div>
          </div>

          <div className='col-lg-6'>
            <label className='required fw-bold fs-6 mb-2'>Exchange</label>

            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='exchange'
              placeholder='Select Exchange'
            >
              <option value='all'>All</option>
              <option value='NSE'>NSE</option>
              <option value='BSE'>BSE</option>
            </Field>

            <div className='text-danger mt-2'>
              <ErrorMessage name='exchange' />
            </div>
          </div>
        </div>
        <div className='row mb-4'>
          <div className='col-lg-6'>
            <label htmlFor='type' className='text-dark fw-bold fs-14 mb-2'>
              Type
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='type'
              placeholder='Select Type'
              multiple
              size={3}
            >
              {schemes
                ? schemes
                    .filter((d: any) => {
                      for (let i = 0; i < userInvestments.length; i++) {
                        if (d.id == userInvestments[i].schemeId) {
                          // console.log(d)
                          return d
                        }
                        // return false
                      }
                    })
                    // remove duplicates
                    .filter(
                      (d: any, i: any, a: any) =>
                        a.findIndex((t: any) => t.typeId === d.typeId) === i
                    )
                    .map((d: any) => (
                      <option key={d.typeId} value={d.typeId}>
                        {types[d.typeId - 1]?.exchangeType}
                      </option>
                    ))
                : null}
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='type' />
            </div>
          </div>

          <div className='col-lg-6'>
            <label htmlFor='subType' className='text-dark fw-bold fs-14 mb-2'>
              Sub-Type
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='subType'
              placeholder='Select Sub-Type'
              multiple
              size={3}
            >
              {schemes
                ? schemes
                    .filter((d: any) => {
                      for (let i = 0; i < userInvestments.length; i++) {
                        if (d.id == userInvestments[i].schemeId) {
                          return d
                        }
                        // return false
                      }
                    })
                    // remove duplicates
                    .filter(
                      (d: any, i: any, a: any) =>
                        a.findIndex((t: any) => t.subTypeId === d.subTypeId) === i
                    )
                    .map((d: any) => (
                      <option key={d.subTypeId} value={d.subTypeId}>
                        {subTypes[d.subTypeId - 1]?.exchangeSubType}
                      </option>
                    ))
                : null}
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='subType' />
            </div>
          </div>
        </div>

        <div className='row mb-4'>
          <div className='col-lg-6'>
            <label htmlFor='amc' className='text-dark fw-bold fs-14 mb-2'>
              AMC
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='amc'
              placeholder='Select AMC'
              multiple
              size={3}
            >
              {schemes
                ? schemes
                    .filter((d: any) => {
                      for (let i = 0; i < userInvestments.length; i++) {
                        if (d.id == userInvestments[i].schemeId) {
                          return d
                        }
                        // return false
                      }
                    })
                    // remove duplicates
                    .filter(
                      (d: any, i: any, a: any) => a.findIndex((t: any) => t.amcId === d.amcId) === i
                    )
                    .map((d: any) => (
                      <option key={d.amcId} value={d.amcId}>
                        {amcs[d.amcId - 13]?.exchangeAssetManagementCompany}
                      </option>
                    ))
                : null}
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='amc' />
            </div>
          </div>

          <div className='col-lg-6'>
            <label htmlFor='scheme' className='text-dark fw-bold fs-14 mb-2'>
              Scheme
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='scheme'
              placeholder='Select Scheme'
              multiple
              size={3}
            >
              {schemes &&
                schemes
                  .filter((d: any) => {
                    for (let i = 0; i < userInvestments.length; i++) {
                      // console.log(userInvestments)
                      if (d.id == userInvestments[i].schemeId) {
                        // console.log(userInvestments[i])
                        return d
                      }
                      // return false
                    }
                  })
                  .map((d: any) => (
                    <option key={d.id} value={d.id}>
                      {d.schemeName}
                    </option>
                  ))}
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='scheme' />
            </div>
          </div>
        </div>

        <div className='row mb-4'>
          <div className='col-lg-6'>
            <label htmlFor='trxnMode' className='text-dark fw-bold fs-14 mb-2'>
              Trxn Mode
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='trxnMode'
              placeholder='Select Trxn Mode'
              multiple
              size={3}
            >
              <option value='' disabled>
                Select Trxn Mode
              </option>
              <option value='online'>Online</option>
              <option value='offline'>Offline</option>
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='trxnMode' />
            </div>
          </div>

          <div className='col-lg-6'>
            <label htmlFor='trxnType' className='text-dark fw-bold fs-14 mb-2'>
              Trxn Type
            </label>
            <Field
              as='select'
              className='form-control form-select border border-primary'
              name='trxnType'
              placeholder='Select Trxn Type'
              multiple
              size={3}
            >
              <option value='all'>All</option>
              <option value='pip'>Purchase (PIP)</option>
              <option value='sip'>Purchase (SIP)</option>
            </Field>
            <div className='text-danger mt-2'>
              <ErrorMessage name='trxnType' />
            </div>
          </div>
        </div>
      </div>

      <div className='fv-row'>
        <div className='row'>
          <div className='col-lg-6'>
            <label htmlFor='startDate' className='text-dark fw-bold fs-14'>
              Start Date
            </label>
            <Field
              type='date'
              className='form-control border border-primary'
              name='startDate'
              max={
                new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)
                  .toISOString()
                  .split('T')[0]
              }
            />
            <div className='text-danger mt-2'>
              <ErrorMessage name='startDate' />
            </div>
          </div>
          <div className='col-lg-6'>
            <label htmlFor='endDate' className='text-dark fw-bold fs-14'>
              End Date
            </label>
            <Field
              type='date'
              className='form-control border border-primary'
              name='endDate'
              max={
                new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)
                  .toISOString()
                  .split('T')[0]
              }
            />
            <div className='text-danger mt-2'>
              <ErrorMessage name='endDate' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Step2}
